import { Box, Card, formatDate, getSpacing, Typography } from "@compass/core";
import { MatchDataProvider, useMatchData } from "../contexts";
import { DashboardPieChart } from "./DashboardPieChart";
import { DashboardCard } from "../components/DashboardCard";


const MatchChartCardContent = () => {
    const { pieChartRows, loading, reportDateFrom, reportDateTo } = useMatchData();

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <Box sx={{ flexGrow: 1, minHeight: 0 }}>
                <DashboardPieChart rows={pieChartRows} loading={loading} />
            </Box>
            <Box pt={getSpacing("lg")}>
                <Typography variant="caption">
                    Report dates: {formatDate(reportDateFrom)}
                    <> to </>
                    {formatDate(reportDateTo)}
                </Typography>
            </Box>
        </Box>
    );
};

export const MatchChartCard = () => {
    return (
        <MatchDataProvider>
            <DashboardCard title="Match Contribution">
                <MatchChartCardContent />
            </DashboardCard>
        </MatchDataProvider>
    );
};